<template>
  <div style="width: 100%">
    <vxe-table border auto-resize resizable show-overflow keep-source :data="tableData">
      <!-- <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column> -->
      <vxe-table-column type="expand" width="60">
        <template #content="{ row }">
          <ExpandTable :fetchTableData="row.paymentList" />
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-for="(item, index) of tableColumn"
        :key="index"
        :field="item.field"
        :title="item.title"
        :edit-render="item.itemRender"
        :minWidth="item.width"
      >
        <template v-slot="{ row }">
          <template v-if="item.field === 'overdueFlag'">
            <span v-if="item.field == '0'">未逾期</span>
            <span>逾期</span>
          </template>
          <template v-else>{{ row[item.field] }}</template>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  import ExpandTable from './ExpandTable';
  export default {
    name: 'HistoryExecuteTable',
    props: {
      fetchTableData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        tableColumn: [
          {
            title: '收费项目',
            field: 'payService',
            width: 150,
          },
          {
            title: '总金额',
            field: 'totalAmount',
            width: 150,
          },
          {
            title: '已收款金额',
            field: 'receivedAmount',
            width: 150,
          },
          {
            title: '未收款金额',
            field: 'unPaymentAmount',
            width: 250,
          },
          {
            title: '是否逾期',
            field: 'overdueFlag',
            width: 250,
          },
        ],
        tableData: [],
      };
    },
    components: {
      ExpandTable,
    },
    watch: {
      fetchTableData: {
        handler(val) {
          if (val && Object.keys(val).length) {
            this.tableData = [
              {
                payService: val.payService,
                totalAmount: val.totalAmount,
                receivedAmount: val.receivedAmount,
                unPaymentAmount: val.unPaymentAmount,
                overdueFlag: val.overdueFlag,
                paymentList: val.paymentList,
              },
            ];
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
